import React from 'react';
import { useTranslation } from '../context/LanguageContext';

const AVAILABLE_LANGUAGES = [
  { code: 'nl', label: 'NL' },
  { code: 'de', label: 'DE' }
];

function LanguageSwitcher({ className = '' }) {
  const { language, setLanguage, dictionary } = useTranslation();
  const label = dictionary.common?.languageSwitcherLabel || 'Language';

  return (
    <div className={`language-switcher ${className}`.trim()} aria-label={label}>
      {AVAILABLE_LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          type="button"
          className={language === lang.code ? 'active' : ''}
          aria-pressed={language === lang.code}
          onClick={() => setLanguage(lang.code)}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
